import { useLocation, useOutlet } from 'react-router-dom';

function transitionKey(pathname: string): string {
  const docsRoute = pathname.match(/^(\/[^/]+\/docs)(?:\/.*)?$/);

  if (docsRoute) {
    return docsRoute[1];
  }

  return pathname;
}

export function PortalPageTransition() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <div
      key={transitionKey(location.pathname)}
      className='animate-fade-in motion-reduce:animate-none'
    >
      {outlet}
    </div>
  );
}
